export const DashboardLibraryTabTypes = ['synced-steps', 'organization-templates', 'content'];
export type DashboardLibraryTabType = typeof DashboardLibraryTabTypes[number];
